import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgR4 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 34 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M25.12 17c1.35 0 2.58.537 3.481 1.411a4.985 4.985 0 011.516 3.438h0l.758 25a4.984 4.984 0 01-1.357 3.578 4.984 4.984 0 01-3.506 1.571h0L9.123 52c-1.38 0-2.63-.56-3.535-1.464a4.984 4.984 0 01-1.465-3.552h0l.76-25.135a4.985 4.985 0 011.516-3.438A4.985 4.985 0 019.881 17h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.984 27c.791 0 1.514.307 2.052.812.538.505.891 1.207.942 1.996h0l.384 6a2.99 2.99 0 01-.742 2.174 2.99 2.99 0 01-2.095 1.014h0L11.632 39a2.99 2.99 0 01-2.121-.879 2.99 2.99 0 01-.879-2.156h0l.39-6.157c.05-.79.404-1.491.942-1.996A2.992 2.992 0 0112.016 27h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				cx: 17,
				cy: 22,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				cx: 10,
				cy: 45,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				cx: 25,
				cy: 45,
				r: 2
			}),
			/* @__PURE__ */ _jsxs("g", {
				fill: "#0D0E10",
				children: [/* @__PURE__ */ _jsxs("g", {
					transform: "translate(5 56.502)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							x: 4.238,
							width: 15,
							height: 2,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 3.238,
							y: 3,
							width: 18,
							height: 2,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: .238,
							y: 6,
							width: 24,
							height: 2,
							rx: 1
						})
					]
				}), /* @__PURE__ */ _jsx("path", { d: "M31.946 64.04l-5.372-7.03a1 1 0 01.143-1.367l.016-.014a.913.913 0 011.32.139l5.373 7.03a1 1 0 01-.143 1.366l-.016.014a.913.913 0 01-1.32-.139zM2.054 64.04l5.372-7.03a1 1 0 00-.143-1.367l-.016-.014a.913.913 0 00-1.32.139l-5.373 7.03a1 1 0 00.143 1.366l.016.014a.913.913 0 001.32-.139z" })]
			})
		]
	})
});
export default SvgR4;
